"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Buttons = require("./../Buttons");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Box = _styledComponents.default.div.withConfig({
  displayName: "Box"
})(["display:flex;background-color:#f7f7f7;height:7.5rem;justify-content:space-between;align-items:center;padding:18px 9.7vw 17px 1.56vw;box-sizing:border-box;"]);

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper"
})(["width:100%;height:100%;box-sizing:border-box;display:flex;justify-content:space-between;"]);

var ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "ButtonWrapper"
})(["border-left:1px solid ", ";padding-left:2rem;"], function (_ref) {
  var theme = _ref.theme;
  return theme.ui.outline;
});

ButtonWrapper.displayName = 'ButtonWrapper';

var InnerBox = _styledComponents.default.div.withConfig({
  displayName: "InnerBox"
})(["position:relative;display:flex;align-items:center;height:100%;input{border:none;background-color:inherit;}"]);

InnerBox.displayName = 'InnerBox';

var ToolBar = function ToolBar(_ref2) {
  var btnName = _ref2.btnName,
      btnDisable = _ref2.btnDisable,
      className = _ref2.className,
      children = _ref2.children,
      level = _ref2.level,
      onClick = _ref2.onClick,
      otherProps = _objectWithoutProperties(_ref2, ["btnName", "btnDisable", "className", "children", "level", "onClick"]);

  return /*#__PURE__*/_react.default.createElement(Box, _extends({
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(InnerBox, null, children), /*#__PURE__*/_react.default.createElement(ButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Buttons.ActionButton, {
    disabled: btnDisable,
    level: level,
    onClick: onClick,
    padding: "0.5rem 1.5rem"
  }, btnName))));
};

ToolBar.defaultProps = {
  btnName: 'New claim',
  level: 'primary',
  btnDisable: false,
  onClick: Function.prototype,
  otherProps: {}
};
ToolBar.propTypes = {
  /** Button name */
  btnName: _propTypes.string,

  /** Disable button */
  btnDisable: _propTypes.bool,

  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,
  level: _propTypes.string,
  onClick: _propTypes.func,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  children: _propTypes.node
};
ToolBar.displayName = 'ToolBar';
var _default = ToolBar;
exports.default = _default;